import { http } from '../../config/axios'

export default function putEstornarFaturamento(faturamento: any): Promise<string> {
  return http
    .put('api/faturamento/estornar', faturamento)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put estornar Faturamento', error)
      throw Error(error.response.data)
    })
}
